<ngb-timepicker [(ngModel)]="timeObject" [meridian]="true" [disabled]="disabled" [hourStep]="disabled ? 0 : 1" [minuteStep]="disabled ? 0 : 5"
    [spinners]="!disabled">
</ngb-timepicker>
 